module.exports = ({React,connect,DataGrid,collectionSearch,LuluActions})=>


  LuluList = (props)=>

    columns = [
      {field: 'id',label: 'Job Id',width:80}
      {field: 'status',label: 'Job Status',width:120}
      {field: 'transaction_id',label: 'Transaction Id',width:120}
      {field: 'items',label: 'No. Items',width:150}
      {field: 'items_status',label: 'Item Status',width:300}
      {field: 'created_at',label: 'Created',width:150,type:"dateTime"}
      {field: 'last_updated',label: 'Updated',width:150,type:"dateTime"}
    ]

    <div style={{ height: '100%' }}>
      <DataGrid 
        rows={props.lulus} 
        selected={props.lulusSelected} 
        columns={columns} 
        onRowClick={(selectedRows)=> props.dispatch(LuluActions.lulusAreSelected(selectedRows))}
        onRowDoubleClick={(selectedRows)=> props.onEdit()} 
      />
      {if props.lulusAreLoading 
         <div className="react-grid-FooterRow"><span className="fa fa-refresh fa-spin" /> Loading Lulus</div>
       else
         <div className="react-grid-FooterRow">{props.lulus.length} Lulus</div>
      }
    </div>
 
  #this updates this componet when state.lulus / lulusSelected changes, wraps component and passed items into props.items
  return connect(
    (state)=>
      filters = {}
      return ({
        lulus: collectionSearch(state.lulus,filters,state.lulusSearchTerm),
        lulusAreLoading: state.lulusAreLoading,
        lulusSelected: state.lulusSelected
      })
    )(LuluList)

